export function Loading() {
  return (
    <div className="flex h-96 items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-black"></div>
    </div>
  );
}
